import React from "react";
import "./ThankyouScreen.scss"
import { Thankyou } from "components/thankyou";
import { Header } from "components/header";
import { CardLayout } from "components/cardLayout";
import { amslogo, logo, ThankYouIcon } from 'assets/images';
import { navigate } from "@reach/router";
import { updateLead } from "core/services/updateLeadStatusService"
import { sendTextMessageToCustomer } from "core/services/sendTextMessageToCustomerService"
import { isMobile } from "core/utils";

declare global {
    interface Window { dataLayer: any; }
}
window.dataLayer = window.dataLayer || {};
export interface ThankyouScreenProps {
    affirmCard?: any;
}

export interface ThankyouScreenState {
    Customer: any;
    amounts: any;
}

class ThankyouScreen extends React.Component<ThankyouScreenProps, ThankyouScreenState> {
    constructor(props: ThankyouScreenProps) {
        super(props);
        this.state = {
            Customer: JSON.parse(localStorage.getItem("customerDetails") || '{}'),
            amounts: JSON.parse(localStorage.getItem("amounts") || '{}')
        };

    }
    onLeftIconPress() {
        navigate('/');
    }

    async updateLeadStatus() {

        var customerID = this.state.Customer.customerID
        var moveID = this.state.Customer.moveID
        var moveDailySheetID = this.state.Customer.moveDailySheetID
        var customerPh = this.state.Customer.customerPh.replace("-", "").replace("-", "")
        var customerName = this.state.Customer.customerName
        var deposit = "$" + this.state.amounts.find((item: any) => item.type === "Deposit").amount;
        // var phno = this.state.Customer.
        console.log("calling update lead service................")
        let response = await updateLead(customerID, moveID, moveDailySheetID);
        if (localStorage.getItem("isAffirm") === "0")
            var response_sms = await sendTextMessageToCustomer(customerID, customerPh, customerName, deposit);

        console.log(response)

    }

    componentDidMount() {
        window.dataLayer.push({
            event: 'pageview',
            page: { path: "/newThankyou" }
        })
        console.log("updating lead status................")
        if (localStorage.getItem("isPaymentDone") === "true") {
            this.updateLeadStatus()
        }
        //localStorage.removeItem("isAffirm")
        // }

    }
    goToPreviousPage() {
        navigate(-1)
    }
    render() {
        const isPaymentDone = localStorage.getItem("isPaymentDone");
        var customerDetails: any = JSON.parse(localStorage.getItem("customerDetails") || '{}');
        var name = customerDetails?.estimatorName;
        var email = customerDetails?.customerEmail;
        return (
            <div style={{height:'100vh'}}>
                <Header
                    //backIcon={true}
                    // leftIcon={'home'}
                    //  leftText={'Home'}
                    rightIcon={"phone"}
                    rightText={"Call Us"}
                    progress={100}
                //onBackPress={this.goToPreviousPage}
                // onLeftIconPress={this.onLeftIconPress}
                />
                <div className={"thankyou-container"}>

                    {/* <div className="thankyou-title">
                        <h1>Thank You!</h1>
                    </div>
                    <div className="thankyou-subtitle">
                        <h2>Your move is booked! Don’t forget to add your Move Day to your calendar.</h2>
                    </div> */}
                    <CardLayout style={{ padding: 0 }}>
                        <div className="thankyou-head">
                            <img src={ThankYouIcon} />
                            <br />
                            <div className="thankyou-subtitle">
                                <h2>{isPaymentDone === "true" ? "Your Move is Booked" : "Thank you for allowing us the opportunity to move you! " + name + " will be calling you as soon as possible to discuss your estimate."}</h2>
                            </div>
                        </div>
                    </CardLayout>
                    <CardLayout>
                        <div className="thankyou-description">
                            <h2>We’ve received your signed estimate! A copy has been emailed to {email}.
                                <span><br />NEXT<br /></span>
                                Please be sure to sign your Bill of Lading (Service Contract), outlining your price options and service terms.
                                <br />
                                To protect you, Federal Law requires the Interstate Bill of Lading to be signed 36 hours prior to servicing you!
                                <br />
                            </h2>
                        </div>
                    </CardLayout>
                    <Thankyou />
                    {this.props.affirmCard &&
                        <CardLayout>
                            <div className="thankyou-logo">
                                <img src={logo} alt="logo" />
                                <p>+</p>
                                <img src={amslogo} alt="amslogo" />
                            </div>
                            <div className="confirm-email">
                                <p>You’re financing your move with Affirm. Check your email for payment details.</p>
                            </div>
                        </CardLayout>
                    }
                    <br />
                </div>
            </div>
        );
    }
}

export default ThankyouScreen;